import RouteContainer from "./lib/routes/container/RouteContainer";
import "bootstrap-icons/font/bootstrap-icons.css";
import "./lib/chartjs";

export default function App() {
  return <RouteContainer />;
}
